var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuppressor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.8004 16.3875H71.2629L76.9404 17.823L78.3399 21.51H102.944L105.065 22.326L104.972 23.559H107.153V34.7895H104.608L104.411 37.6605L102.454 39.0315H95.6019L94.4274 39.5535H79.3539L74.3289 43.599L73.4589 43.926H23.2374V41.8995L20.4969 41.9025L16.7124 38.901C16.7124 38.901 13.7529 35.0655 13.7529 27.3585C13.7529 19.6515 15.1089 19.0965 15.1089 19.0965L18.8004 16.389V16.3875Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8794 23.559H79.5509V28.4595H82.8794V23.559Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4569 24.6615H82.8789V27.3585H87.4569V24.6615Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4988 35.7675H78.9258V38.124H88.4988V35.7675Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0537 35.7675V38.124",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1621 35.7675V38.124",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2715 35.7675V38.124",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3799 35.7675V38.124",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4904 35.7675V38.124",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.008 32.2828H101.274H99.3551L98.5391 34.3978H100.399H103.341",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.274 32.283L100.399 34.398",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2984 33.6149C75.8509 33.6149 76.2989 33.3228 76.2989 32.9624C76.2989 32.6021 75.8509 32.3099 75.2984 32.3099C74.7458 32.3099 74.2979 32.6021 74.2979 32.9624C74.2979 33.3228 74.7458 33.6149 75.2984 33.6149Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9361 29.5175L38.9351 29.5164C38.5691 29.0783 37.9174 29.02 37.4794 29.3859L32.8106 33.2869C32.3726 33.6529 32.3142 34.3046 32.6801 34.7426L32.6811 34.7438C33.0471 35.1818 33.6988 35.2402 34.1369 34.8742L38.8056 30.9733C39.2437 30.6073 39.3021 29.9555 38.9361 29.5175Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0074 29.5165L34.0064 29.5154C33.6404 29.0774 32.9887 29.019 32.5507 29.385L27.8819 33.2859C27.4438 33.6519 27.3854 34.3036 27.7514 34.7417L27.7524 34.7428C28.1184 35.1808 28.7701 35.2392 29.2081 34.8732L33.8769 30.9723C34.315 30.6063 34.3734 29.9546 34.0074 29.5165Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0788 29.5172L29.0778 29.5161C28.7118 29.078 28.0601 29.0196 27.6221 29.3856L22.9533 33.2866C22.5153 33.6526 22.4569 34.3043 22.8228 34.7423L22.8238 34.7435C23.1898 35.1815 23.8415 35.2399 24.2796 34.8739L28.9483 30.973C29.3864 30.607 29.4448 29.9552 29.0788 29.5172Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.801 16.3875H71.2635L76.941 17.823C76.941 17.823 78.768 21.738 78.246 29.046C77.724 36.354 76.0275 39.8775 76.0275 39.8775L70.611 41.64L22.65 41.901H20.496L16.7115 38.8995C16.7115 38.8995 13.752 35.115 13.752 27.1545C13.752 19.194 15.6675 18.5415 15.6675 18.5415L18.7995 16.3875H18.801Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0856 16.3875C21.0856 16.3875 18.0181 18.672 18.6061 28.329C19.1941 37.986 22.6516 41.901 22.6516 41.901",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8009 16.3875C18.8009 16.3875 15.4079 17.106 16.1249 28.6545C16.8419 40.203 20.4974 41.901 20.4974 41.901",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2638 16.3875C71.2638 16.3875 73.6458 19.8465 73.4493 27.6764C73.2528 35.5064 70.6113 41.64 70.6113 41.64",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3408 21.51H103.695L105.065 22.326L104.972 23.559L104.412 31.005L102.846 35.964L102.455 39.0315H95.6028L94.8198 39.5535H79.3548L74.3313 43.599L73.4613 43.9245H23.2383V41.898",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M104.971 23.559H107.152V34.7895H104.608",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8428 38.7705V35.7675L98.6038 31.005L99.1918 21.51",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0704 31.0049H104.412V37.6604L102.454 39.0314",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0704 33.8099H92.2094L94.2974 35.4419L96.8429 35.7674",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuppressor);
export default __webpack_public_path__ + "static/media/Suppressor.967c221f3a4a43366e21a1e65a20de5c.svg";
export { ForwardRef as ReactComponent };